import React from 'react'
import TrainerMyCourses from '../../features/trainer/TrainerMyCourses'

const TrainerMyCoursesPage = () => {
  return (
   <TrainerMyCourses/>
  )
}

export default TrainerMyCoursesPage